<app-page-meta pageTitle="finzy - Loan Application"></app-page-meta>
<app-header [secondaryLogoUrl]="partnerLogoUrl"></app-header>

<div class="row mainrow">
  <div class="col-sm-4 leftdiv">
    <app-loan-application-left-div></app-loan-application-left-div>
  </div>
  <div class="col-xs-12 col-sm-8 rightdiv">
    <div *ngIf="!isFirstPage()" class="mobileleftdiv">
      <app-borrower-registration-progress-bar></app-borrower-registration-progress-bar>
    </div>
    <div class="rightinnerdiv">
      <router-outlet (activate)="onLoad()"></router-outlet>
    </div>
  </div>
</div>
<app-footer></app-footer>
